import { tw } from '@panwds/tailwindcss';
import { isNil, isNilOrEmptyString } from '../../utils/index.js';
export const AppearanceStyleMap = {
    solid: 'Solid',
    subdued: 'Subdued'
};
export const appearanceClassMap = {
    // solid
    red: tw `twds-bg-red-500`,
    blue: tw `twds-bg-blue-600`,
    teal: tw `twds-bg-teal-400 dark:twds-bg-teal-400 twds-text-primary`,
    lightBlue: tw `twds-bg-blue-200 dark:twds-bg-blue-700 twds-text-primary dark:twds-text-blue-100`,
    // solid
    skySolid: tw `twds-bg-sky-300 dark:twds-bg-sky-600 twds-text-primary dark:twds-text-primary-dark`,
    purpleSolid: tw `twds-bg-purple-300 dark:twds-bg-purple-800 twds-text-primary dark:twds-text-primary-dark`,
    cyanSolid: tw `twds-bg-cyan-300 dark:twds-bg-cyan-600 twds-text-primary dark:twds-text-primary-dark`,
    greenSolid: tw `twds-bg-green-300 dark:twds-bg-green-700 twds-text-primary dark:twds-text-primary-dark`,
    pinkSolid: tw `twds-bg-pink-300 dark:twds-bg-pink-600 twds-text-primary dark:twds-text-primary-dark`,
    indigoSolid: tw `twds-bg-indigo-300 dark:twds-bg-indigo-700 twds-text-primary dark:twds-text-primary-dark`,
    limeSolid: tw `twds-bg-lime-300 dark:twds-bg-lime-700 twds-text-primary dark:twds-text-primary-dark`,
    graySolid: tw `twds-bg-gray-300 dark:twds-bg-gray-900 twds-text-primary dark:twds-text-primary-dark`,
    // subdued
    skySubdued: tw `twds-bg-sky-100 twds-border-sky-600 dark:twds-bg-sky-1000 dark:twds-border-sky-600 twds-text-primary dark:twds-text-primary-dark twds-border-solid !twds-border-[1px] twds-leading-4.5`,
    purpleSubdued: tw `twds-bg-purple-100 twds-border-purple-400 dark:twds-bg-purple-1000 dark:twds-border-purple-600 twds-text-primary dark:twds-text-primary-dark twds-border-solid !twds-border-[1px] twds-leading-4.5`,
    cyanSubdued: tw `twds-bg-cyan-100 twds-border-cyan-600 dark:twds-bg-cyan-900 dark:twds-border-cyan-500 twds-text-primary dark:twds-text-primary-dark twds-border-solid !twds-border-[1px] twds-leading-4.5`,
    greenSubdued: tw `twds-bg-green-100 twds-border-green-500 dark:twds-bg-green-1000 dark:twds-border-green-600 twds-text-primary dark:twds-text-primary-dark twds-border-solid !twds-border-[1px] twds-leading-4.5`,
    pinkSubdued: tw `twds-bg-pink-100 twds-border-pink-500 dark:twds-bg-pink-1000 dark:twds-border-pink-600 twds-text-primary dark:twds-text-primary-dark twds-border-solid !twds-border-[1px] twds-leading-4.5`,
    indigoSubdued: tw `twds-bg-indigo-100 twds-border-indigo-600 dark:twds-bg-indigo-1000 dark:twds-border-indigo-700 twds-text-primary dark:twds-text-primary-dark twds-border-solid !twds-border-[1px] twds-leading-4.5`,
    limeSubdued: tw `twds-bg-lime-100 twds-border-lime-500 dark:twds-bg-lime-1000 dark:twds-border-lime-600 twds-text-primary dark:twds-text-primary-dark twds-border-solid !twds-border-[1px] twds-leading-4.5`,
    graySubdued: tw `twds-bg-gray-100 twds-border-gray-500 dark:twds-bg-gray-950 dark:twds-border-gray-600 twds-text-primary dark:twds-text-primary-dark twds-border-solid !twds-border-[1px] twds-leading-4.5`
};
export const SeverityMap = {
    critical: 'Critical',
    high: 'High',
    medium: 'Medium',
    low: 'Low',
    lowest: 'Lowest',
    success: 'Success',
    informational: 'Informational'
};
export const SeverityClassMap = {
    // solid
    criticalSolid: tw `twds-bg-magenta-300 dark:twds-bg-magenta-700 twds-text-primary dark:twds-text-primary-dark`,
    highSolid: tw `twds-bg-red-300 dark:twds-bg-red-600 twds-text-primary dark:twds-text-primary-dark`,
    mediumSolid: tw `twds-bg-orange-300 dark:twds-bg-orange-500 twds-text-primary dark:twds-text-primary`,
    lowSolid: tw `twds-bg-yellow-400 dark:twds-bg-yellow-400 twds-text-primary dark:twds-text-primary`,
    lowestSolid: tw `twds-bg-yellow-200 dark:twds-bg-yellow-200 twds-text-primary dark:twds-text-primary`,
    successSolid: tw `twds-bg-teal-300 dark:twds-bg-teal-600 twds-text-primary dark:twds-text-primary-dark`,
    // subdued
    criticalSubdued: tw `twds-bg-magenta-100 twds-border-magenta-600 dark:twds-bg-magenta-900 twds-text-primary dark:twds-text-primary-dark twds-border-solid !twds-border-[1px] twds-leading-4.5`,
    highSubdued: tw `twds-bg-red-100 twds-border-red-500 dark:twds-bg-red-900 dark:twds-border-red-600 twds-text-primary dark:twds-text-primary-dark twds-border-solid !twds-border-[1px] twds-leading-4.5`,
    mediumSubdued: tw `twds-bg-orange-100 twds-border-orange-400 dark:twds-bg-orange-900 dark:twds-border-orange-600 twds-text-primary dark:twds-text-primary-dark twds-border-solid !twds-border-[1px] twds-leading-4.5`,
    lowSubdued: tw `twds-bg-yellow-200 twds-border-yellow-400 dark:twds-bg-yellow-900 dark:twds-border-yellow-500 twds-text-primary dark:twds-text-primary-dark twds-border-solid !twds-border-[1px] twds-leading-4.5`,
    lowestSubdued: tw `twds-bg-yellow-100 twds-border-yellow-200 dark:twds-bg-yellow-900 dark:twds-border-yellow-200 twds-text-primary dark:twds-text-primary-dark twds-border-solid !twds-border-[1px] twds-leading-4.5`,
    successSubdued: tw `twds-bg-teal-100 twds-border-teal-400 dark:twds-bg-teal-800 dark:twds-border-teal-500 twds-text-primary dark:twds-text-primary-dark twds-border-solid !twds-border-[1px] twds-leading-4.5`,
    informationalSubdued: tw `twds-bg-sky-100 twds-border-sky-600 dark:twds-bg-sky-1000 dark:twds-border-sky-600 twds-text-primary dark:twds-text-primary-dark twds-border-solid !twds-border-[1px] twds-leading-4.5`
};
export const getClassNamesBySizeForCircleShape = (size) => {
    switch (size) {
        case '2xs':
            return tw `twds-py-[1px] twds-px-1.5 twds-rounded-full`;
        case 'xs':
            return tw `twds-text-2xs twds-leading-4 twds-px-1 twds-rounded-full`;
        case 'sm':
            return tw `twds-py-0.5 twds-px-2 twds-rounded-full`;
        case 'md':
            return tw `twds-py-[3px] twds-px-2.5 twds-rounded-full`;
        default:
            return tw `twds-py-1 twds-px-3 twds-rounded-full`;
    }
};
/*export const getClassNamesBySizeForCircleShape = (size: string) => {
    switch (size) {
        case '2xs':
            return tw`twds-py-0.5 twds-px-[3px] twds-rounded-full`
        case 'xs':
            return tw`twds-py-0.5 twds-px-1 twds-rounded-full`
        case 'sm':
            return tw`twds-py-0.5 twds-px-2 twds-rounded-full`
        case 'md':
            return tw`twds-py-[3px] twds-px-2.5 twds-rounded-full`
        default:
            return tw`twds-py-1 twds-px-3 twds-rounded-full`
    }
}*/
export const getClassNamesBySizeForSquareShape = (size) => {
    switch (size) {
        case '2xs':
            return tw `twds-py-0 twds-px-1 twds-rounded`;
        case 'xs':
            return tw `twds-py-0 twds-px-1 twds-rounded`;
        case 'sm':
            return tw `twds-py-0 twds-px-1 twds-rounded`;
        default:
            return tw `twds-py-1 twds-px-2 twds-rounded`;
    }
};
export const getSeverityClassType = (severity, appearanceStyle) => {
    if (!severity || !appearanceStyle)
        return;
    switch (severity) {
        case 'critical':
        case 'high':
        case 'medium':
        case 'low':
        case 'lowest':
        case 'success':
            return `${severity}${AppearanceStyleMap[appearanceStyle]}`;
        case 'informational':
            return 'informationalSubdued';
    }
};
export const getAppearanceClassType = (appearance, appearanceStyle) => {
    if (!appearance)
        return;
    switch (appearance) {
        case 'red':
        case 'blue':
        case 'teal':
        case 'lightBlue':
            return `${appearance}`;
        //case 'lightBlue':
        case 'sky':
        case 'purple':
        case 'cyan':
        case 'green':
        case 'pink':
        case 'indigo':
        case 'lime':
        case 'gray':
            return `${appearance}${AppearanceStyleMap[appearanceStyle ?? 'solid']}`;
    }
};
export const getOverrideClassName = (props) => {
    const { severity, appearanceStyle, overrideAppearance, appearance } = props;
    const severityClassType = getSeverityClassType(severity, appearanceStyle);
    let classNames = '';
    if (!isNilOrEmptyString(severityClassType) || severityClassType !== undefined) {
        classNames = SeverityClassMap[severityClassType];
    }
    else if (!isNilOrEmptyString(overrideAppearance) && overrideAppearance !== undefined) {
        classNames = overrideAppearance;
    }
    else if (!isNilOrEmptyString(appearance) && appearance !== undefined) {
        const appearanceClassType = getAppearanceClassType(appearance, appearanceStyle);
        if (!isNil(appearanceClassType)) {
            classNames = appearanceClassMap[appearanceClassType];
        }
    }
    return classNames;
};
export const SeverityLevelNo = {
    critical: 5,
    high: 4,
    medium: 3,
    low: 2,
    lowest: 1
};
export const RiskPriorityClassMap = {
    critical: tw `twds-bg-magenta-600 dark:twds-bg-magenta-600 twds-text-white dark:twds-text-white twds-leading-4.5`,
    high: tw `twds-bg-red-500 dark:twds-bg-red-500 twds-text-white dark:twds-text-white twds-leading-4.5`,
    medium: tw `twds-bg-orange-400  dark:twds-bg-orange-400 twds-text-black dark:twds-text-black twds-leading-4.5`,
    low: tw `twds-bg-yellow-400 dark:twds-bg-yellow-400 twds-text-black dark:twds-text-black twds-leading-4.5`,
    lowest: tw `twds-bg-yellow-300 dark:twds-bg-yellow-300 twds-text-black dark:twds-text-black twds-leading-4.5`
};
export const getRiskOverrideClassNames = (severity) => {
    return RiskPriorityClassMap[severity];
};
//# sourceMappingURL=BadgeUtils.js.map